import React, { useState } from 'react'
import "../styles/Header.css"
import { Link } from "react-router-dom";
import { FaGithub, FaMedium, FaLinkedin } from "react-icons/fa";

function Header() {
  const [isNavExpanded, setIsNavExpanded] = useState(false)
  const closeMenu = () => setIsNavExpanded(false)

  return (
    <nav className="navigation">

      <button
        className="hamburger"
        onClick={() => {
          setIsNavExpanded((prev) => !prev)
        }}
      >

        <div className="hamburger-line" />
        <div className="hamburger-line" />
        <div className="hamburger-line" />

      </button>
      <div
        className={
          isNavExpanded ? "navigation-menu expanded" : "navigation-menu"
        }
      >
        <ul>
          <li className="nav-brand">
            <Link className="home-headingw" to="/" onClick={closeMenu}>Kaan 🧑🏻‍💻</Link>
          </li>
          <li className="nav-links">
            <Link className="nav-link" to="/" onClick={closeMenu}>Home</Link>
            <span className="nav-separator">|</span>
            <Link className="nav-link" to="/posts" onClick={closeMenu}>Posts</Link>
            <span className="nav-separator">|</span>
            <Link className="nav-link" to="/projects" onClick={closeMenu}>Projects</Link>
          </li>
          <li className="social-links">
            <a className="home-headingw social-link" href="https://github.com/knhakan" title='Github' onClick={closeMenu}><FaGithub size={'20px'} /></a>
            <a className="home-headingw social-link" href="https://medium.com/@kaanonsoftware" title='Medium' onClick={closeMenu}><FaMedium size={'20px'} /></a>
            <a className="home-headingw social-link" href="https://linkedin.com/in/kaan-hakan/" title='Linkedin' onClick={closeMenu}><FaLinkedin size={'20px'} /></a>
          </li>
        </ul>
      </div>
    </nav>
  )
}

export default Header